import { widgetsRuntimeSource } from "./runtimeSource";

const CSP =
  "default-src 'none'; " +
  "script-src 'unsafe-inline' 'self'; " +
  "style-src 'unsafe-inline'; " +
  "img-src 'self' data:; " +
  "connect-src 'none'; " +
  "frame-src 'none'; " +
  "base-uri 'none'; " +
  "form-action 'none'";

const THEME_CSS = `
  body { margin: 0; font: 14px -apple-system, BlinkMacSystemFont, "Inter", sans-serif; color: #1f1f23; }
  * { box-sizing: border-box; }
`;

function sanitizeUserHtml(html) {
  // Keep one closing </html> only — ours, at the end. Strip any in user-supplied html.
  return String(html ?? "").replace(/<\/\s*html\s*>/gi, "");
}

export function composeWidgetDocument(userHtml, theme = {}) {
  const safe = sanitizeUserHtml(userHtml);
  return `<!DOCTYPE html>
<html>
<head>
<meta charset="UTF-8">
<meta http-equiv="Content-Security-Policy" content="${CSP}">
<style>${THEME_CSS}</style>
<script>${widgetsRuntimeSource}</script>
</head>
<body>
${safe}
</body>
</html>`;
}
